export default __webpack_public_path__ + "static/chocpops-health-2-mobile-ffe7ef01ad9903890c9a2ed267238da0.png";